export default __webpack_public_path__ + "static/media/3.0e31b34c.jpg";